<div class="flex justify-content-start">
    <div class="mr-2">
        <button
            id="{{ idPrefix + '_search' }}"
            pButton
            (click)="onSearchClicked()"
            [disabled]="searchDisabled == null ? false : searchDisabled"
            label="{{ hrKey.common.buttonSearch | translate }}"
            class="p-button"
        >
            <i class="material-icons">search</i>
        </button>
    </div>
    <div class="mr-2" *ngIf="showClearButton">
        <button id="{{ idPrefix + '_btnSearchClear' }}" pButton (click)="onClearClicked()" label="{{ hrKey.common.buttonClear | translate }}" class="mr-2 p-button-outlined"></button>
    </div>
</div>
